import React, { useState, useMemo, useCallback } from "react";
import * as rankFilters from "./Rank/rank-filters";
import * as playedChampionsFilters from "./PlayedChampions/played-champions-filters";
import * as matchHistoryFilters from "./MatchHistory/match-history-filters";
import * as lpFilters from "./LPBlock/lp-filters";

export const defaultOverviewFilters = {
  rankBlock: {
    seasonId: rankFilters.SEASON_OPTIONS[0].value,
  },
  playerStats: {
    queueType: playedChampionsFilters.QUEUE_TYPE_OPTIONS[0].value,
  },
  matchHistory: {
    queueType: matchHistoryFilters.QUEUE_TYPE_OPTIONS[0].value,
    championId: null,
    duoName: null,
  },
  lp: {
    queueType: lpFilters.QUEUE_TYPE_OPTIONS[0].value,
  },
};

export const useFilters = (filters, setFilters) => {
  const filtersByCategory = (filterCategory) => {
    return { ...filters[filterCategory] };
  };

  const setFilterCategory = (filterCategory) => {
    return (newFilters) => {
      setFilters({ ...filters, [filterCategory]: newFilters });
    };
  };

  return useCallback(
    (filterCategory) => {
      return [filtersByCategory(filterCategory), setFilterCategory(filterCategory)];
    },
    [filters, setFilters],
  );
};
